import React from "react";
import { barChartItem } from '../../domain/barChart';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import './index.css';

interface Props {
  barChartItem: barChartItem[],
  classes: any
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    charts: {
      width: '90%',
      height: '100%',
      top: 0,
      left: 0,
      zIndex: 10,
      // eslint-disable-next-line
      ['@media (min-width:780px)']: {
        width: '80%',
        margin: '0% 10%',
      }
    },
    chartUl: {
      listStyle: "none",
      // eslint-disable-next-line
      ['@media (min-width:780px)']: {
      }
    },
    chartLi: {
      'nth-of-type(1)': {
        animationDelay: '0.7s',
      },
      'nth-of-type(2)': {
        animationDelay: '0.9s',
      },
      'nth-of-type(3)': {
        animationDelay: '1.1s',
      },
      'nth-of-type(4)': {
        animationDelay: '1.3s',
      },
      'nth-of-type(5)': {
        animationDelay: '1.5s',
      },
      'nth-of-type(6)': {
        animationDelay: '1.7s',
      },
      'nth-of-type(7)': {
        animationDelay: '1.9s',
      },
      'nth-of-type(8)': {
        animationDelay: '2.1s',
      },
      'nth-of-type(9)': {
        animationDelay: '2.3s',
      },
      'nth-of-type(10)': {
        animationDelay: '2.5s',
      },
      'nth-of-type(11)': {
        animationDelay: '2.7s',
      },
    },
    chartLabel: {
      paddingLeft: '10px',
      lineHeight: '30px',
      color: 'white',
      fontWeight: 'bold',
    },
  }),
);


const BarChart: React.FC<Props> = (props) => {
  const classes = props.classes();
  const classesCommon = useStyles();
  const list = props.barChartItem.map((item, index) => {
    const itemName = item['itemName'];
    const percentage = item['itemPercentage'];
    const percentageToString = `${percentage}%`;
    return (
      <li key={index} className={classes.chartLi + ' ' + classesCommon.chartLi} style={{width: percentageToString}}>
        <span className={classesCommon.chartLabel}>
          {itemName}
        </span>
      </li>
    );
  });
  return (
      <div id="skills">
        <div className="skill-content">
          <div className={classesCommon.charts}>
            <div className="chart chart--dev">
              <ul className={classesCommon.chartUl}>{list}</ul>
            </div>
          </div>
        </div>
      </div>
  );
};


export default BarChart;
